import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import printJS from "print-js"; // Pastikan Anda menginstal printJS
import { useAuth } from "hooks/useAuth";
import { useMeal } from "contexts/v1/masterData/MealContext";
import { URLS } from "utils/constants";
import { postRequest } from "services/api";
import { useUpdateData } from "hooks/useApiHooks";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import { Button, Col, Row } from "react-bootstrap";

const PrintTicket = ({ initialData, onSuccess, onError }) => {
  const API_URL = `/reservation/${initialData.id}/meal`; // URL API untuk memperbarui meal berdasarkan reservation ID
  const { meals } = useMeal(); // Ambil data meal dari context
  const [includedItems, setIncludedItems] = useState([]);
  const { updateData: updateMeal } = useUpdateData(API_URL);
  const { user } = useAuth();

  console.log("PrintTicket initialData", initialData); // Debug initialData

  // **Konversi meals ke format yang sesuai saat initialData berubah**
  useEffect(() => {
    if (meals && initialData?.reservation_meal) {
      const mealData = meals.data.map((meal) => {
        const reservationMeal = initialData.reservation_meal.find(
          (rm) => rm.meal_id === meal.id
        );
        return {
          meal_id: meal.id,
          name: meal.name,
          qty: reservationMeal ? reservationMeal.quantity : 0, // Update berdasarkan data yang ada di initialData
          note: reservationMeal ? reservationMeal.note : "", // Update berdasarkan data yang ada di initialData
        };
      });
      setIncludedItems(mealData);
      console.log("Included Items:", mealData); // Debug includedItems
    }
  }, [meals, initialData]); // Akan dipanggil ulang jika meals atau initialData berubah

  // **Handle perubahan quantity atau note pada meal**
  const handleMealChange = (index, key, value) => {
    const updatedMeals = [...includedItems];
    updatedMeals[index][key] = value;
    setIncludedItems(updatedMeals);
  };

  const { handleSuccessToast, handleError } = useCanvasHandler();

  // **Handle submit untuk mengirim PUT request**
  const handleSubmit = async () => {
    // Validasi data
    if (includedItems.some((item) => item.qty <= 0)) {
      handleError("Quantity must be greater than 0.");
      return;
    }

    // Prepare payload for API request
    const mealData = includedItems.map((item) => ({
      meal_id: item.meal_id,
      quantity: item.qty,
      note: item.note,
    }));

    console.log("Payload untuk API:", mealData); // Debug payload

    // Send PUT request to update meals
    try {
      const reservation_id = initialData.id; // Ambil reservation_id dari initialData
      const url = `${API_URL}`; // API URL yang digunakan

      // Kirimkan data meal
      await updateMeal({ meals: mealData }, url);

      Swal.fire("Success", "Meals updated successfully", "success");
      if (typeof onSuccess === "function") onSuccess();
    } catch (error) {
      console.error("Error updating meals:", error);
      Swal.fire("Error", "Failed to update meals.", "error");
      if (typeof onError === "function") onError();
    }
  };

  // Filter activities berdasarkan type
  const mainActivities = initialData.activities?.filter(
    (activity) => activity.type === "product"
  );

  // Menampilkan semua aktivitas baik 'product' maupun 'extra'
  const allActivities = initialData.activities?.filter(
    (activity) => activity.type === "product" || activity.type === "extra"
  );

  const handlePrint = () => {
    Swal.fire({
      title: "Confirm Print",
      text: "Are you sure you want to print this ticket 3 times?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Print!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const labels = ["GUIDE", "RESTO", "CUSTOMER"];
        let currentIndex = 0;

        const printNext = () => {
          if (currentIndex >= labels.length) {
            onSuccess();
            return;
          }

          const label = labels[currentIndex];
          const invoiceContent = `
          <html>
            <head>
              <title>Print Ticket</title>
              <style>
                @page { size: 58mm auto; margin: 0; }
                body { font-family: Arial, sans-serif; text-align: center; width: 58mm; margin: 0; padding: 5px; }
                table { width: 100%; border-collapse: collapse; font-size: 14px; }
                th, td { padding: 2px 5px; text-align: left; }
                .title { font-size: 16px; font-weight: bold; }
                .label { font-size: 14px; font-weight: bold; text-transform: uppercase; }
                .track { font-size: 35px; font-weight: bold; margin: 5px 0; }
                .border-dashed { border-bottom: 1px dashed #000; margin: 5px 0; }
                .text-right { text-align: right; }
                .text-center { text-align: center; }
                .small { font-size: 9px; }
              </style>
            </head>
            <body>
              <div class="text-center">
                <h1 class="label">${label}</h1>
                <img src="/Kuber.jpeg" alt="Company Logo" style="width: 60px; height: auto;" />
                <p class="small">Br. Bayad, Desa Melinggih Kelod, Payangan, Gianyar, Bali 80572</p>
              </div>
  
              <div class="border-dashed"></div>
              <h3 class="title">TICKET</h3>
              <table>
                <tr><td>Code</td><td class="text-right">${
                  initialData.code
                }</td></tr>
                <tr><td>Date</td><td class="text-right">${initialData.reservation_date || "-"}</td></tr>
                <tr><td>Print Date</td><td class="text-right">${date}</td></tr>
                <tr><td>Print Time</td><td class="text-right">${time}</td></tr>
                <tr><td>Guest</td><td class="text-right">${
                  initialData.customer?.name || "-"
                }</td></tr>
                <tr><td>Hotel</td><td class="text-right">${
                  initialData.customer?.nationality || "-"
                }</td></tr>
                <tr><td>Total Pax</td><td class="text-right">${
                  initialData.guest_pax
                }</td></tr>
              </table>
  
              <div class="border-dashed"></div>
              <h3 class="title">Main Activities</h3>
              <table>
                <tr><th>Activity</th><th class="text-right">Qty</th></tr>
                ${allActivities
                  .map(
                    (activity) =>
                      `<tr><td style="font-size:18px;font-weight:bold;">${activity.activity}</td><td class="text-right">${activity.qty}</td></tr>`
                  )
                  .join("")}
              </table>              
  
              <div class="border-dashed"></div>
              <h3 class="title">Trip Option</h3>
              <p class="small">${initialData.trip?.name} - ${
            initialData.trip.start_time
          } - ${initialData.trip.end_time} </p>
              <p class="track">${
                initialData.track === "A" ? "PREMIUM" : "REGULAR"
              }</p>
  
              <div class="border-dashed"></div>
              <h3 class="title">Host</h3>
              <p>${user.name}</p>
              <p>______________________</p>
  
              <div class="border-dashed"></div>
              <h3 class="title">Meals Voucher</h3>
               <table>
                <tr><th>Item</th><th class="text-right">Qty</th></tr>
                ${includedItems
                  .map(
                    (item) =>
                      `<tr><td>${item.name}</td><td class="text-right">${item.qty}</td></tr>
                      <tr><td colspan="2"><strong>Note:</strong> <em>${item.note}</em></td></tr>`
                  )
                  .join("")}
              </table>
  
              <div class="border-dashed"></div>
              <p class="small">Thank you for choosing our service!</p>
            </body>
          </html>`;

          printJS({
            printable: invoiceContent,
            type: "raw-html",
            targetStyles: ["*"],
            onPrintDialogClose: () => {
              currentIndex++;
              setTimeout(printNext, 500);
            },
          });
        };

        printNext();
      } else {
        Swal.fire("Cancelled", "Print operation cancelled.", "info");
      }
    });
  };

  // handle print Meal only
  const handlePrintMealOnly = () => {
    Swal.fire({
      title: "Confirm Print",
      text: "Are you sure you want to print this ticket 2 times?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Print!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const labels = ["RESTO", "CUSTOMER"];
        let currentIndex = 0;

        const printNext = () => {
          if (currentIndex >= labels.length) {
            onSuccess();
            return;
          }

          const label = labels[currentIndex];
          const invoiceContent = `
          <html>
            <head>
              <title>Print Ticket</title>
              <style>
                @page { size: 58mm auto; margin: 0; }
                body { font-family: Arial, sans-serif; text-align: center; width: 58mm; margin: 0; padding: 5px; }
                table { width: 100%; border-collapse: collapse; font-size: 14px; }
                th, td { padding: 2px 5px; text-align: left; }
                .title { font-size: 16px; font-weight: bold; }
                .label { font-size: 14px; font-weight: bold; text-transform: uppercase; }
                .track { font-size: 35px; font-weight: bold; margin: 5px 0; }
                .border-dashed { border-bottom: 1px dashed #000; margin: 5px 0; }
                .text-right { text-align: right; }
                .text-center { text-align: center; }
                .small { font-size: 9px; }
              </style>
            </head>
            <body>
              <div class="text-center">
                <h1 class="label">${label}</h1>
                <img src="/Kuber.jpeg" alt="Company Logo" style="width: 60px; height: auto;" />
                <p class="small">Br. Bayad, Desa Melinggih Kelod, Payangan, Gianyar, Bali 80572</p>
              </div>
  
              <div class="border-dashed"></div>
              <table>
                <tr><td>HOST</td><td class="text-right">${user.name}</td></tr>
                <tr><td>Code</td><td class="text-right">${
                  initialData.code
                }</td></tr>
                <tr><td>Date</td><td class="text-right">${initialData.reservation_date || "-"}</td></tr>
                <tr><td>Print Date</td><td class="text-right">${date}</td></tr>
                <tr><td>Print Time</td><td class="text-right">${time}</td></tr>
                <tr><td>Guest</td><td class="text-right">${
                  initialData.customer?.name || "-"
                }</td></tr>
                <tr><td>Hotel</td><td class="text-right">${
                  initialData.customer?.nationality || "-"
                }</td></tr>
                <tr><td>Total Pax</td><td class="text-right">${
                  initialData.guest_pax
                }</td></tr>
              </table>
              <h3 class="title">Meals Voucher</h3>
               <table>
                <tr><th>Item</th><th class="text-right">Qty</th></tr>
                ${includedItems
                  .map(
                    (item) =>
                      `<tr><td>${item.name}</td><td class="text-right">${item.qty}</td></tr>
                      <tr><td colspan="2"><strong>Note:</strong> <em>${item.note}</em></td></tr>`
                  )
                  .join("")}
              </table>
  
              <div class="border-dashed"></div>
              <p class="small">Thank you for choosing our service!</p>
            </body>
          </html>`;

          printJS({
            printable: invoiceContent,
            type: "raw-html",
            targetStyles: ["*"],
            onPrintDialogClose: () => {
              currentIndex++;
              setTimeout(printNext, 500);
            },
          });
        };

        printNext();
      } else {
        Swal.fire("Cancelled", "Print operation cancelled.", "info");
      }
    });
  };

  // handle print Ticket only
  const handlePrintTicketOnly = () => {
    Swal.fire({
      title: "Confirm Print",
      text: "Are you sure you want to print this ticket 3 times?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Print!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const labels = ["GUIDE", "RESTO", "CUSTOMER"];
        let currentIndex = 0;

        const printNext = () => {
          if (currentIndex >= labels.length) {
            onSuccess();
            return;
          }

          const label = labels[currentIndex];
          const invoiceContent = `
            <html>
              <head>
                <title>Print Ticket</title>
                <style>
                  @page { size: 58mm auto; margin: 0; }
                  body { font-family: Arial, sans-serif; text-align: center; width: 58mm; margin: 0; padding: 5px; }
                  table { width: 100%; border-collapse: collapse; font-size: 14px; }
                  th, td { padding: 2px 5px; text-align: left; }
                  .title { font-size: 16px; font-weight: bold; }
                  .label { font-size: 14px; font-weight: bold; text-transform: uppercase; }
                  .track { font-size: 35px; font-weight: bold; margin: 5px 0; }
                  .border-dashed { border-bottom: 1px dashed #000; margin: 5px 0; }
                  .text-right { text-align: right; }
                  .text-center { text-align: center; }
                  .small { font-size: 9px; }
                </style>
              </head>
              <body>
                <div class="text-center">
                  <h1 class="label">${label}</h1>
                  <img src="/Kuber.jpeg" alt="Company Logo" style="width: 60px; height: auto;" />
                  <p class="small">Br. Bayad, Desa Melinggih Kelod, Payangan, Gianyar, Bali 80572</p>
                </div>
    
                <div class="border-dashed"></div>
                <table>
                  <tr><td>HOST</td><td class="text-right">${user.name}</td></tr>
                  <tr><td>Code</td><td class="text-right">${
                    initialData.code
                  }</td></tr>
                  <tr><td>Date</td><td class="text-right">${initialData.reservation_date || "-"}</td></tr>
                  <tr><td>Print Date</td><td class="text-right">${date}</td></tr>
                  <tr><td>Print Time</td><td class="text-right">${time}</td></tr>
                  <tr><td>Guest</td><td class="text-right">${
                    initialData.customer?.name || "-"
                  }</td></tr>
                  <tr><td>Hotel</td><td class="text-right">${
                    initialData.customer?.nationality || "-"
                  }</td></tr>
                  <tr><td>Total Pax</td><td class="text-right">${
                    initialData.guest_pax
                  }</td></tr>
                </table>
    
                <div class="border-dashed"></div>
                <h3 class="title">Main Activities</h3>
                <table class="bordered">
                  <tr><th>Activity</th><th class="text-right">Qty</th></tr>
                  ${allActivities
                    .map(
                      (activity) =>
                        `<tr><td style="font-size:18px;font-weight:bold;">${activity.activity}</td><td class="text-right">${activity.qty}</td></tr>`
                    )
                    .join("")}
                </table>              
    
                <div class="border-dashed"></div>
                <h3 class="title">Trip Option</h3>
                <p class="small">${initialData.trip?.name} - ${
            initialData.trip.start_time
          } - ${initialData.trip.end_time} </p>
                <p class="track">${
                  initialData.track === "A" ? "PREMIUM" : "REGULAR"
                }</p>
    
                <div class="border-dashed"></div>
                <h3 class="title">Host</h3>
                <p>${user.name}</p>
    
                <div class="border-dashed"></div>
                <p class="small">Thank you for choosing our service!</p>
              </body>
            </html>`;

          printJS({
            printable: invoiceContent,
            type: "raw-html",
            targetStyles: ["*"],
            onPrintDialogClose: () => {
              currentIndex++;
              setTimeout(printNext, 500);
            },
          });
        };

        printNext();
      } else {
        Swal.fire("Cancelled", "Print operation cancelled.", "info");
      }
    });
  };
  // Format tanggal dan waktu

  const today = new Date();
  const date = today.toLocaleDateString("id-ID", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  const time = today.toLocaleTimeString("id-ID", {
    hour: "2-digit",
    minute: "2-digit",
    // second: "2-digit",
    hour12: false,
  });

  const [isProcessing, setIsProcessing] = useState(false);

  const handleSaveAndPrint = async () => {
    setIsProcessing(true);
    try {
      await handleSubmit();
      handlePrint();
    } catch (error) {
      console.error("Gagal menyimpan dan mencetak!", error);
      Swal.fire("Error", "Failed to save and print.", "error");
    } finally {
      setIsProcessing(false);
    }
  };
  const handleSaveAndPrintMealOnly = async () => {
    setIsProcessing(true);
    try {
      await handleSubmit();
      handlePrintMealOnly();
    } catch (error) {
      console.error("Gagal menyimpan dan mencetak!", error);
      Swal.fire("Error", "Failed to save and print.", "error");
    } finally {
      setIsProcessing(false);
    }
  };
  const handleSaveAndPrintTicketOnly = async () => {
    setIsProcessing(true);
    try {
      await handleSubmit();
      handlePrintTicketOnly();
    } catch (error) {
      console.error("Gagal menyimpan dan mencetak!", error);
      Swal.fire("Error", "Failed to save and print.", "error");
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <form className="d-flex flex-column" style={{ height: "100%" }}>
      <div className="action-sheet-content flex-grow-1">
        <div className="form-group mb-3">
          <label className="form-label">Meals</label>
          {includedItems.map((item, index) => (
            <div key={index} className="row mt-2">
              <div className="col-md-4">
                <label className="form-label">Item</label>
                <input
                  type="text"
                  value={item.name}
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-md-2">
                <label className="form-label">Quantity</label>
                <input
                  type="text"
                  value={item.qty}
                  className="form-control"
                  min="1"
                  onChange={(e) =>
                    handleMealChange(index, "qty", Number(e.target.value))
                  }
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Note</label>
                <input
                  type="text"
                  value={item.note}
                  className="form-control"
                  onChange={(e) =>
                    handleMealChange(index, "note", e.target.value)
                  }
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Submit Button */}
      {/* <button
        type="button"
        className="btn btn-primary"
        onClick={handleSaveAndPrint}
        disabled={isProcessing}
      >
        {isProcessing ? "Processing..." : "Save & Print"}
      </button> */}
      <Row className="mt-3">
        <Col md={4}>
          <Button
            variant="primary"
            onClick={() => handleSaveAndPrint("Save & Print")}
            disabled={isProcessing}
            block
          >
            {isProcessing ? "Processing..." : "Save & Print"}
          </Button>
        </Col>
        <Col md={4}>
          <Button
            variant="primary"
            onClick={() => handleSaveAndPrintMealOnly("Save & Print Meal Only")}
            disabled={isProcessing}
            block
          >
            {isProcessing ? "Processing..." : "Save & Print Meal Only"}
          </Button>
        </Col>
        <Col md={4}>
          <Button
            variant="primary"
            onClick={() =>
              handleSaveAndPrintTicketOnly("Save & Print Ticket Only")
            }
            disabled={isProcessing}
            block
          >
            {isProcessing ? "Processing..." : "Save & Print Ticket Only"}
          </Button>
        </Col>
      </Row>
    </form>
  );
};

export default PrintTicket;
